import { gql } from '@apollo/client';

export const PROJECTS = gql`
  query McadminProjects {
    projects: mcadminProjects {
      id
      name
      title
      domains {
        id
        name
      }
    }
  }
`;
